import React, {Component} from 'react'
import ReactJson from 'react-json-view'
import { Dropdown } from 'semantic-ui-react'
import DocsGetResponseCode from "./DocsGetResponseCode";

class DocsGetResponse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataFormat: 'jsonRow'
        }

        this.handleFormatChange = this.handleFormatChange.bind(this);
    }

    handleFormatChange(event, {value}){
        this.setState({
            dataFormat: value
        })
    }

    render() {
        const responseBody =
            {
                jsonRow: {
                    "data": [
                        {
                            "name": "Bon Jovi",
                            "address": "Cool Dr",
                            "isCustomer": true,
                            "totalSales": 45.43
                        },
                        {
                            "name": "Tom Hanks",
                            "address": "Awesome Ave",
                            "isCustomer": false,
                            "totalSales": 0
                        }
                    ]
                },
                matrix: {
                    "data":
                    [
                        ["Bon Jovi", "Cool Dr", true, 45.53],
                        ["Tom Hanks", "Awesome Ave", false, 0]
                    ]
                },
                jsonColumn: {
                    "name": ["Bon Jovi", "Tom Hanks"],
                    "address": ["Cool Dr", "Awesome Ave"],
                    "isCustomer": [true, false],
                    "totalSales": [45.53, 0]
                }
            }

        const dataFormatOptions = [
            {key: 1, text: 'jsonRow', value: 'jsonRow'},
            {key: 2, text: 'matrix', value: 'matrix'},
            {key: 3, text: 'jsonColumn', value: 'jsonColumn'},
        ];

        const dataFormat = this.state.dataFormat;

        return (
            <div className="getResponseBox">
                <div className="getResponseHeading">
                    <span style={{float: 'left'}}><h6 className="thinHeading">Response Body</h6></span>
                    <span style={{float: 'right'}}> {' '}
                        <Dropdown
                            placeholder="Select Data Format"
                            name="dataFormat"
                            value={dataFormat}
                            options={dataFormatOptions}
                            onChange={this.handleFormatChange}
                            inline
                        />
                    </span>
                </div>
                <ReactJson src={responseBody[dataFormat]} name={null} theme="ocean" displayObjectSize={false}/>
                <DocsGetResponseCode/>
            </div>
        )
    }
}

export default DocsGetResponse